import { ReactNode } from "react"
import { ListItem, ListItemLabel, useStyletron } from "@mezo-org/mezo-clay"

export type BorrowReviewListItemProps = {
  header?: string
  description?: ReactNode
  endHeader?: ReactNode
  endDescription?: string
  hasLightHeader?: boolean
  hasBorder?: boolean
  margin?: string
}

export default function BorrowReviewListItem({
  header,
  description,
  endHeader,
  endDescription,
  margin,
  hasLightHeader = false,
  hasBorder = false,
}: BorrowReviewListItemProps) {
  const [_, theme] = useStyletron()

  const headerStyleOverrides = hasLightHeader
    ? theme.typography.ParagraphMedium
    : {}

  return (
    <ListItem
      overrides={{
        Root: {
          style: {
            background: "transparent",
            alignItems: "flex-start",
            margin,
          },
        },
        Content: {
          style: {
            alignItems: "flex-start",
            gap: theme.sizing.scale600,
            minHeight: 0,
            borderWidth: hasBorder ? "1px" : 0,
          },
        },
      }}
      endEnhancer={() => (
        <ListItemLabel
          overrides={{
            LabelContent: {
              style: {
                ...headerStyleOverrides,
                marginBottom: theme.sizing.scale100,
              },
            },
            LabelDescription: {
              style: {
                ...theme.typography.ParagraphSmall,
                color: theme.colors.contentSecondary,
              },
            },
            LabelRoot: {
              style: {
                textAlign: "right",
                flex: "1 1 0",
              },
            },
          }}
          description={endDescription}
        >
          {endHeader}
        </ListItemLabel>
      )}
    >
      <ListItemLabel
        description={description}
        overrides={{
          LabelRoot: {
            style: { flex: "1 1 0" },
          },
          LabelContent: {
            style: {
              ...headerStyleOverrides,
              marginBottom: theme.sizing.scale100,
            },
          },
          LabelDescription: {
            style: {
              ...theme.typography.ParagraphSmall,
              color: theme.colors.contentSecondary,
            },
          },
        }}
      >
        {header}
      </ListItemLabel>
    </ListItem>
  )
}
